import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgMeatball(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.05005 16.0005C5.05005 17.464 6.23649 18.6505 7.70005 18.6505C9.1636 18.6505 10.35 17.464 10.35 16.0005C10.35 14.5369 9.1636 13.3505 7.70005 13.3505C6.23649 13.3505 5.05005 14.5369 5.05005 16.0005Z"
      />
      <path
        fill="currentColor"
        d="M13.3489 16.0005C13.3489 17.464 14.5353 18.6505 15.9989 18.6505C17.4624 18.6505 18.6489 17.464 18.6489 16.0005C18.6489 14.5369 17.4624 13.3505 15.9989 13.3505C14.5353 13.3505 13.3489 14.5369 13.3489 16.0005Z"
      />
      <path
        fill="currentColor"
        d="M24.2997 18.6505C22.8361 18.6505 21.6497 17.464 21.6497 16.0005C21.6497 14.5369 22.8361 13.3505 24.2997 13.3505C25.7632 13.3505 26.9497 14.5369 26.9497 16.0005C26.9497 17.464 25.7632 18.6505 24.2997 18.6505Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMeatball);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
